import { useContext, useCallback } from 'react'
import { LangContext } from '../contexts/Lang.context'
import { tr } from '../utils/tr.util'
import { StringMap } from '@naturalcycles/js-lib/types'
import { TrKey } from '../cnst/translations/trKey.cnst'

export type Tr = (key: TrKey, params?: StringMap) => string

export const useTr = (): { tr: Tr } => {
  const { currentLang } = useContext(LangContext)

  const translate = useCallback(
    (key: TrKey, params?: StringMap) => tr(key, params, currentLang),
    [currentLang]
  )

  return { tr: translate }
}
